import {
    API,
    CLEAR_NOTIFICATIONS,
    LOAD_NOTIFICATIONS,
    NOTIFICATION_MARK_AS_READ,
    NOTIFICATION_MARK_AS_READ_ALL,
    NOTIFICATION_PUSHED,
    NOTIFICATION_REMOVE_FROM_TOASTS,
    NOTIFICATIONS_LOADED
} from './types';

export const loadNotifications = () => (dispatch) => {
    dispatch({ type: LOAD_NOTIFICATIONS });
    dispatch({
        type: API,
        payload: {
            url: 'notifications',
            method: 'GET',
            onSuccess: (data) => {
                dispatch({ type: NOTIFICATIONS_LOADED, payload: data });
            }
        }
    });
};

export const notificationPushed = (notification) => {
    return {
        type: NOTIFICATION_PUSHED,
        payload: notification
    };
};

export const notificationMarkAsRead = (id) => (dispatch) => {
    dispatch({
        type: API,
        payload: {
            url: 'notifications/' + id,
            method: 'POST',
            onSuccess: () => {
                dispatch({
                    type: NOTIFICATION_MARK_AS_READ,
                    payload: id
                });
            }
        }
    });
};

export const markAsReadAllNotifications = () => (dispatch) => {
    dispatch({
        type: API,
        payload: {
            url: 'notifications',
            method: 'POST',
            onSuccess: () => {
                dispatch({
                    type: NOTIFICATION_MARK_AS_READ_ALL
                });
            }
        }
    });
};

export const clearNotifications = () => (dispatch) => {
    dispatch({
        type: API,
        payload: {
            url: 'notifications',
            method: 'DELETE',
            onSuccess: () => {
                dispatch({ type: CLEAR_NOTIFICATIONS });
            }
        }
    });
};

export const removeNotificationFromToasts = (id) => {
    return {
        type: NOTIFICATION_REMOVE_FROM_TOASTS,
        payload: id
    };
};
